import { useCompany } from '@/data/company';
import { useRoles } from '@/data/role';
import { PageLoading, PageError } from '@/app/ui/page';

const CompanyAuthentication = ({ children }) => {
  const company = useCompany();
  // Roles load here, alongside the company, because useUserRoles derives every access
  // gate in the app from the current user's assigned role. Gating them at the root is
  // what lets those call sites read role data without each carrying its own guard.
  const roles = useRoles();

  if (company.isLoading && !company.data) {
    return <PageLoading variant="app" />;
  }

  if (roles.isLoading && !roles.data) {
    return <PageLoading variant="app" />;
  }

  if (company.error) {
    return <PageError message="An error occurred loading company. Try logging out and logging back in." />;
  }

  if (roles.error) {
    return <PageError message="An error occurred loading roles. Try logging out and logging back in." />;
  }

  return children;
};

export default CompanyAuthentication;
